import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "",
  style: {}
}
const _hoisted_2 = {
  key: 0,
  class: "fl"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "fl mt6 ml20",
  style: {"width":"300px"}
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_ZoomSelectContent = _resolveComponent("ZoomSelectContent")!
  const _component_SelectLocationsList = _resolveComponent("SelectLocationsList")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_TextfieldTag, {
        placeholder: "場所",
        style: {"border-bottom":"solid 1px #c8c8c8","height":"40px"},
        class: "cal_blanks fw600 fl fs12 pad10 dgrey mt2 ml5 mr10",
        value: _ctx.location,
        onInputValue: _ctx.inputLocation,
        onClickTextfield: _ctx.clickTextfield,
        onBlur: _ctx.blurTextfield
      }, null, 8, ["value", "onInputValue", "onClickTextfield", "onBlur"]),
      (_ctx.location)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/close_circle.png`),
              width: "22",
              height: "24",
              style: {},
              class: "mt12 ml5 pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteLocation && _ctx.deleteLocation(...args)))
            }, null, 8, _hoisted_3), [
              [_directive_tooltip, `場所情報を削除`]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.location == _ctx.Const.zoomConnectAccount && _ctx.zoomLoctags)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ZoomSelectContent, {
              zoomLoctags: _ctx.zoomLoctags,
              sZooms: _ctx.selectedZooms,
              unZooms: _ctx.unselectedZooms,
              provider: `zoom`,
              maxLength: _ctx.maxLength,
              onUpdate: _ctx.updateZoomAccounts
            }, null, 8, ["zoomLoctags", "sZooms", "unZooms", "maxLength", "onUpdate"])
          ]))
        : (_ctx.location == _ctx.Const.teamsConnectAccount && _ctx.zoomLoctags)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_ZoomSelectContent, {
                zoomLoctags: _ctx.teamsLoctags,
                sZooms: _ctx.selectedTeams,
                unZooms: _ctx.unselectedTeams,
                provider: `teams`,
                maxLength: _ctx.maxLength,
                onUpdate: _ctx.updateTeamsAccounts
              }, null, 8, ["zoomLoctags", "sZooms", "unZooms", "maxLength", "onUpdate"])
            ]))
          : _createCommentVNode("", true),
      _hoisted_6
    ]),
    (_ctx.showList)
      ? (_openBlock(), _createBlock(_component_SelectLocationsList, {
          key: 0,
          loctags: _ctx.loctags,
          appo: _ctx.appo,
          astag: _ctx.astag,
          hideSelectFreeBox: true,
          selectOne: true,
          onSelect: _ctx.selectLocations,
          class: "mt20"
        }, null, 8, ["loctags", "appo", "astag", "onSelect"]))
      : _createCommentVNode("", true)
  ]))
}